import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { Auth } from '../../../helpers'
import './AnswerToQuestion.css'

class AnswerToQuestion extends Component {
  constructor (props) {
    super(props)
    this.state = {
      answer: ''
    }
  }

  dismissPopup () {
    this.props.dispatch(actions.switchAnswerToQuestionPopup({}))
  }

  replyAnswer () {
    let info = {
      comment: this.props.payload._id,
      participant: Auth.getParticipant(),
      text: this.state.answer
    }
    this.props.dispatch(actions.socketSendMessage({ action: 'answer-comment', data: { answer: info, comment: this.props.payload } }))
  }

  render () {
    return (
      <div className='dashboard-hey email-invite'>
        <div className='hey-popup' style={{ background: 'white' }}>
          <div className='hey-popup-header'>
            <div className='header-text'>Answer to question:</div>

            <img alt='' src='/imgs/close.png' onClick={this.dismissPopup.bind(this)} />
          </div>
          <div className='hey-popup-content'>
            <div className='question-popup'>
              {this.props.payload.text}
            </div>
            <div className='chat-message'>
              <div name='chat-message'>
                <textarea
                  placeholder='Add an answer to the question...'
                  className='chat-message'
                  value={this.state.text}
                  onChange={ev => this.setState({ answer: ev.target.value })} />
              </div>
            </div>
            {this.state.error && (
              <h4><small className='red'>{this.state.error}</small></h4>
            )}
          </div>
          <div className='hey-popup-button-cont'>
            <button
              onClick={this.replyAnswer.bind(this)}
              className='button-bt '>Answer <img alt='' src='/imgs/white-send.png' /></button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    error: state.popup.errors,
    payload: state.popup.payload
  }
}

export default connect(mapStateToProps)(AnswerToQuestion)



// WEBPACK FOOTER //
// ./src/components/common/popups/AnswerToQuestion.js